import { render, staticRenderFns } from "./per-child.vue?vue&type=template&id=2e516c3a&"
import script from "./per-child.vue?vue&type=script&lang=js&"
export * from "./per-child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports